import { Component, ElementRef, HostListener, Input, ViewChild, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { baseSharedActions, baseSharedSelectors } from '../../../_store';
import { SharedState } from '../../../_store/reducers/base-shared.reducer';
import { BaseLanguageSwitchColors } from '../../enums/base-language-switch-colors.enum';
import { BaseLanguage } from '../../enums/base-language.enum';

@Component({
  selector: 'base-language-switch',
  templateUrl: './base-language-switch.component.html',
})
export class BaseLanguageSwitchComponent implements AfterViewInit {
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
  @Input() color: BaseLanguageSwitchColors = BaseLanguageSwitchColors.darkBlue;
  @Input() isDisplayedInSidebar: boolean = false;
  languages = BaseLanguage;
  isOpen = false;
  openUpward = false;
  activeLanguage: string = BaseLanguage.de;

  constructor(private readonly store: Store<SharedState>, private translateService: TranslateService) {
    this.store.select(baseSharedSelectors.getCurrentLanguage).subscribe((value) => {
      this.activeLanguage = value;
      this.translateService.use(value);
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.isOpen) {
      this.adjustDropdownPosition();
    }
  }

  ngAfterViewInit() {
    if (this.isOpen) {
      this.adjustDropdownPosition();
    }
  }

  setLanguage(language: string) {
    this.store.dispatch(baseSharedActions.setLanguage({ language }));
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      setTimeout(() => this.adjustDropdownPosition(), 0);
    }
  }

  close(): void {
    this.isOpen = false;
  }

  private adjustDropdownPosition(): void {
    if (this.dropdownMenu) {
      const rect = this.dropdownMenu.nativeElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const dropdownHeight = this.dropdownMenu.nativeElement.offsetHeight;
      this.openUpward = rect.bottom + dropdownHeight > viewportHeight && rect.top > dropdownHeight;
    }
  }
}
